import { UserModule as UserModuleStruct, UserModuleState } from '@/Store/interfaces/user';
import { UserLoginPayload } from '@/services/Auth/Interfaces';
import { NotificationInterface, NotificationsInterface, ProfileInterface } from '@/services/Users-profile/interfaces';

const UserModule: UserModuleStruct = {
  state: {
    id: 'GuestId',
    profileId: 'GuestId',
    username: 'Guest',
    email: 'Guest@Guest.guest',
    name: 'Guest User',
    jwt: undefined,
    isAdmin: false,
    scopes: [],
    departmentId: 'GuestId',
    wsKey: undefined,
    darkTheme: true,
    showReviewedEscalations: false,
    profileImage: '',
    notifications: {
      unread: [],
      read: [],
    },
  },
  mutations: {
    USER_LOGIN(state: UserModuleState, payload: UserLoginPayload): void {
      state.id = payload.id;
      state.username = payload.username;
      state.email = payload.email;
      state.name = payload.name;
      state.jwt = payload.jwt;
      state.wsKey = payload.wsKey;
      state.scopes = payload.scopes;
      state.departmentId = payload.departmentId;
      state.isAdmin = payload.isAdmin;
    },
    USER_LOGOUT(state: UserModuleState): void {
      state.jwt = undefined;
      state.wsKey = undefined;
      state.id = 'GuestId';
      state.profileId = 'GuestId';
      state.username = 'Guest';
      state.email = 'Guest@Guest.guest';
      state.name = 'Guest User';
      state.scopes = [];
      state.departmentId = 'GuestId';
      state.isAdmin = false;
      state.darkTheme = true;
      state.showReviewedEscalations = false;
      state.profileImage = '';
    },
    UPDATE_SCOPES(state: UserModuleState, scopes: string[]): void {
      state.scopes = scopes;
    },
    UPDATE_THEME(state: UserModuleState, isDark: boolean): void {
      state.darkTheme = isDark;
    },
    SET_PROFILE_DATA(state: UserModuleState, profile: ProfileInterface): void {
      state.name = `${profile.personalDetails.firstName} ${profile.personalDetails.lastName}`;
      state.profileId = String(profile._id);
      state.profileImage = profile.personalDetails.image || '';
      state.darkTheme = profile.profileConfig?.enabledDarkTheme ?? true;
      state.showReviewedEscalations = profile.profileConfig.showReviewedEscalations;
    },
    SET_NOTIFICATIONS(state: UserModuleState, notifications: NotificationsInterface): void {
      state.notifications.unread = notifications.unread;
      state.notifications.read = notifications.read;
    },
    MARK_AS_READ(state: UserModuleState, id: string): void {
      const index = state.notifications.unread.findIndex((n) => n._id === id);
      if (index === -1) {
        return;
      }

      const [notification] = state.notifications.unread.splice(index, 1);
      notification.isRead = true;
      state.notifications.read.unshift(notification);
    },
    MARK_ALL_AS_READ(state: UserModuleState): void {
      const newlyRead = state.notifications.unread.map((n) => ({ ...n, isRead: true }));
      state.notifications.read = [...newlyRead, ...state.notifications.read];
      state.notifications.unread = [];
    },
    SOCKET_notification(state: UserModuleState, notification: NotificationInterface): void {
      const normalized: NotificationInterface = {
        ...(notification),
        date: notification.date ?? new Date().toISOString(),
        isRead: false,
      };

      const exists = state.notifications.unread
        .some(n => n._id === normalized._id);

      if (exists) {
        return;
      }

      state.notifications.unread = [normalized, ...state.notifications.unread];
    },
  },
  getters: {
    jwt: (state: UserModuleState) => {
      if (state.jwt) {
        return `Bearer ${state.jwt}`;
      }

      return null;
    },
    id: (state: UserModuleState) => {
      return state.id;
    },
    wsKey: (state: UserModuleState) => {
      return state.wsKey;
    },
    username: (state: UserModuleState) => {
      return state.username;
    },
    email: (state: UserModuleState) => {
      return state.email;
    },
    name: (state: UserModuleState) => {
      return state.name;
    },
    departmentId: (state: UserModuleState) => {
      return state.departmentId;
    },
    isAdmin: (state: UserModuleState) => {
      return state.isAdmin;
    },
    scopes: (state: UserModuleState) => {
      return state.scopes;
    },
    profileId: (state: UserModuleState) => {
      return state.profileId;
    },
    profileImage: (state: UserModuleState) => {
      if (state.profileImage && state.profileImage !== '') {
        return state.profileImage;
      }

      return undefined;
    },
    darkTheme: (state: UserModuleState) => {
      return state.darkTheme;
    },
    showReviewedEscalations: (state: UserModuleState) => {
      return state.showReviewedEscalations;
    },
    notifications: (state: UserModuleState) => {
      return state.notifications;
    },
  },
};

export default UserModule;
